// dependencies.
// token para api-n1
import token from './token'
import flatten from './flatten'

/**
 * Request interceptors.
 *
 * @param http
 * @param store
 * @param router
 */
export default (apin1, store, router) => {
  // flatten data
  apin1.interceptors.response.use(flatten.success, flatten.error)

  // set authorization token.
  apin1.interceptors.request.use(token(store, router), error => error)
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors-n1/index.js